export default {
  bollean: {
    true: 'Sim',
    false: 'Não'
  },
  alert: {
    error: 'Favor prencher os campos corretamente!',
    delete: 'Tem certeza que deseja excluir este item?'
  },
  title: {
    consult: 'Consulta de ',
    include: 'Inclusão de ',
    edit: 'Edição de ',
    delete: 'Deleção de ',
    management: 'Gerenciamento de '
  },
  field: {
    select: 'Selecione um(a) '
  },
  button: {
    upgrade: {title: 'Atualizar', icon: 'trending_up'},
    add: {title: 'Adicionar', icon: 'add'},
    manage: {title: 'Gerenciar', icon: 'build'},
    save: {title: 'Salvar', icon: 'save'},
    save_close: {title: 'Salvar e Fechar', icon: 'done'},
    save_new: {title: 'Salvar e Novo', icon: 'add'},
    save_manage: {title: 'Salvar e Gerenciar', icon: 'build'},
    edit: {title: 'Editar', icon: 'fa fa-pencil'},
    delete: {title: 'Deletar', icon: 'fa fa-trash'},
    home: {title: 'Página Inicial', icon: 'home'},
    done: {title: 'Confirmar', icon: 'done'},
    exit: {title: 'Sair', icon: 'exit'},
    close: {title: 'Fechar', icon: 'close'},
    build: {title: 'Gerenciar', icon: 'build'}
  },
  table: {
    action: 'Ações',
    decimal: `,`,
    emptyTable: `Nenhum registro encontrado`,
    info: `Exibindo do _START_ ao _END_ de _TOTAL_ registros`,
    infoEmpty: `Exibindo do 0 ao 0 de 0 registros`,
    infoFiltered: `(Filtrado a partir de _MAX_ registros)`,
    infoPostFix: ``,
    thousands: `.`,
    lengthMenu: `Exibir _MENU_ registros`,
    loadingRecords: `Carregando...`,
    processing: `Processando...`,
    search: `Pesquisar`,
    zeroRecords: `Nenhum registro encontrado`,
    paginate: {
      first: `Primeiro`,
      last: `Último`,
      next: `Próximo`,
      previous: `Anterior`
    }
  },
  accesses: {
    modules: 'Módulos',
    analytic: 'Análises'
  }
}



// WEBPACK FOOTER //
// ./src/translate/pt_br/system.js